import React from 'react';
import TvDashboard from '../tvdashboard/TvDashboard';
import PageMetaData from '../common/components/pageMetaData/PageMetaData';

function Dashboard() {
  return (
    <>
      <PageMetaData title="Dashboard" />
      <TvDashboard />
    </>
  );
}

export default Dashboard;
